import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP6ChurnedOvw202507: FaireAdPerformancePeriodEntity = {
  token: "perf_p6_churned_ovw_202507",
  type: "adPerformancePeriod",
  scope: "OVERVIEW",
  periodType: "RECEIPT",
  startDate: "2025-07-01",
  endDate: "2025-07-31",
  impressions: 61453,
  clicks: 1263,
  adsSpendDollars: 1924,
  budgetDollars: 2400,
  salesDollars: 5739,
  bestEstimateRoas: 2.98,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.8,
  newCustomersAcquired: 16,
  reorderConversions: 8,
  dataAvailableAtDate: "2025-08-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
